import { clsx } from '../../../lib/utils';

interface SslMeterProps {
  peakL?: number;
  peakR?: number;
  rmsL?: number;
  rmsR?: number;
  grDb?: number;
  height?: number;
  showGr?: boolean;
  className?: string;
}

function barColor(v: number): string {
  if (v > 0.95) return 'bg-ssl-ledClip';
  if (v > 0.8) return 'bg-ssl-ledWarn';
  return 'bg-ssl-led';
}

function MeterColumn({ value, rms, h }: { value: number; rms: number; h: number }) {
  const peakPct = Math.min(100, Math.max(0, value * 100));
  const rmsPct = Math.min(100, Math.max(0, rms * 100));
  return (
    <div className="relative w-[5px] overflow-hidden rounded-sm bg-black/60" style={{ height: h }}>
      <div
        className={clsx('absolute bottom-0 left-0 right-0 opacity-50', barColor(rms))}
        style={{ height: `${rmsPct}%` }}
      />
      <div
        className={clsx('absolute bottom-0 left-0 right-0', barColor(value))}
        style={{ height: `${peakPct}%` }}
      />
    </div>
  );
}

export function SslMeter({
  peakL = 0,
  peakR = 0,
  rmsL = 0,
  rmsR = 0,
  grDb = 0,
  height = 120,
  showGr = true,
  className,
}: SslMeterProps) {
  const grPct = Math.min(100, (grDb / 24) * 100);
  return (
    <div className={clsx('flex items-end gap-[2px]', className)}>
      <MeterColumn value={peakL} rms={rmsL} h={height} />
      <MeterColumn value={peakR} rms={rmsR} h={height} />
      {showGr && (
        <div className="relative w-[4px] overflow-hidden rounded-sm bg-black/60" style={{ height }} title={`GR ${grDb.toFixed(1)} dB`}>
          <div
            className="absolute bottom-0 left-0 right-0 bg-amber-400/80"
            style={{ height: `${grPct}%` }}
          />
        </div>
      )}
    </div>
  );
}
